import React, { useState } from "react";
import { Shield, ShieldOff, FolderTree } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const CATS = [
  { value: "series", label: "Full Series" },
  { value: "season", label: "Season Pack" },
  { value: "episode", label: "Episode" },
];

export default function ModRowControls({ row, mediaType, onChange }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const isMod = user && (user.role === "admin" || user.role === "mod");
  if (!isMod || !row.info_hash) return null;

  const block = async () => {
    const reason = window.prompt("Reason for blocking (optional):") || "";
    try {
      await api.post("/admin/torrents/block", {
        info_hash: row.info_hash, reason, name: row.name,
      });
      toast.success("Torrent blocked");
      onChange?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Block failed");
    }
  };

  const classify = async (category) => {
    try {
      await api.post("/admin/torrents/classify", {
        info_hash: row.info_hash, category, name: row.name,
      });
      toast.success(`Moved to ${category}`);
      setOpen(false);
      onChange?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Reclassify failed");
    }
  };

  return (
    <div className="relative flex items-center gap-1 ml-1 shrink-0">
      <button
        onClick={block}
        data-testid={`mod-block-${row.info_hash}`}
        title="Block this torrent"
        className="p-1.5 rounded-md hover:bg-red-500/15 text-red-400"
      >
        <Shield className="w-3.5 h-3.5" />
      </button>
      {mediaType === "tv" && (
        <>
          <button
            onClick={() => setOpen((o) => !o)}
            data-testid={`mod-classify-${row.info_hash}`}
            title="Move to correct section"
            className="p-1.5 rounded-md hover:bg-[var(--tt-purple)]/15 text-[var(--tt-purple)]"
          >
            <FolderTree className="w-3.5 h-3.5" />
          </button>
          {open && (
            <div className="absolute right-0 top-full mt-1 z-30 bg-[var(--tt-surface)] border border-[var(--tt-border)] rounded-lg shadow-xl py-1 min-w-[140px]">
              {CATS.map((c) => (
                <button
                  key={c.value}
                  onClick={() => classify(c.value)}
                  data-testid={`mod-classify-${row.info_hash}-${c.value}`}
                  className="block w-full text-left text-xs px-3 py-1.5 hover:bg-white/5"
                >
                  {c.label}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
